// permissionList.js
import axiosInstance from "../../axiosInstance";

// const base = `${process.env.REACT_APP_API_URL || "http://localhost:3001/api"}`;
// const BASE_URL = `${base}/permissions`;

const BASE_URL = "/settings/permissions";

export const getPermissions = (params = {}) =>
  axiosInstance.get(BASE_URL, { params });

export const createPermission = (data) =>
  axiosInstance.post(BASE_URL, data);

export const updatePermission = (code, data) =>
  axiosInstance.put(`${BASE_URL}/${encodeURIComponent(code)}`, data);

export const deletePermission = (code) =>
  axiosInstance.delete(`${BASE_URL}/${encodeURIComponent(code)}`);

// (tuỳ chọn) lấy chi tiết theo code
export const getPermissionByCode = (code) =>
  axiosInstance.get(`${BASE_URL}/${encodeURIComponent(code)}`);
